module.exports = __webpack_public_path__ + "h5/img/xuekelingyu@2x.731ae3ee.png";